import { Button, CloseIcon, Flex, Modal, SearchIcon, Text } from "@pancakeswap/uikit"
import { useState } from "react"
import styled from "styled-components"

interface Range<T> {
    field: string 
    min: T | undefined 
    max: T | undefined
}

export interface TokenFilter {
    query: string
    ranges: Range<number>[]
}

const SearchBox = styled(Flex)`
  flex: 1;
  border: 1px solid #FFFFFF33;
  border-radius: 12px;
  padding: 10px 17px;
  align-items: center;
  svg {
    opacity: 0.3;
  }
  & > input {
    background: transparent;
    border: none;
    outline: 0;
    flex: 1;
    font-size: 14px;
    &::placeholder {
      color: #958BB0;
    }
  }
`

const InputRow = styled(Flex)`
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 16px;
`

const LabelContainer = styled(Flex)`
  width: 110px;
  align-items: center;
`

const InputGroup = styled(Flex)`
  flex: 1;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
`

const InputContainer = styled(Flex)`
  background: #2B2634;
  align-items: center;
  padding: 2px;
  border-radius: 10px;
  width: 100%;
`

const CurrencyBox = styled.div`
  background: #38334D;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  &::before {
    content: '$';
  }
`

const StyledInput = styled.input`
  border: none;
  border-radius: 12px;
  padding: 0 12px;
  background: transparent;
  outline: 0;
  font-size: 14px;
  width: 100%;
  flex: 1;
  &::placeholder {
    color: #958BB0;
  }
`

const FilterLabel = styled(Text)`
  color: white;
  font-size: 14px;
`

const Divider = styled.div`
  height: 1px;
  background: #FFFFFF33;
  margin: 16px 0;
  width: 100%;
`

const FilterTitle = styled(Text)`
  color: #958BB0;
  font-size: 14px;
  margin-bottom: 16px;
  text-align: center;
  width: 60%;
`

const setNumber = (v: string, setter: (v: string) => void) => {
    if (!v)
        setter(undefined)
    else if (/^\.\d*$/.test(v))
        setter(`0${v}`)
    else {
        const matches = /^0*(0\.|\d+(\.\d*)?)$/.exec(v)
        if (matches?.[1])
            setter(matches[1])
    }
}

const RANGES = {
    marketCap: 'Market Cap',
    liquidity: 'Liquidity',
    volume1d: '24H Volume',
}

export const FilterModal = ({
    filter,
    setFilter,
    onDismiss
}: {
    filter: TokenFilter,
    setFilter: any,
    onDismiss?: () => void,
}) => {
    const [query, setQuery] = useState<string>(filter.query)
    const [minValues, setMinValues] = useState<any>(Object.fromEntries(filter.ranges.map(r => [r.field, r.min])))
    const [maxValues, setMaxValues] = useState<any>(Object.fromEntries(filter.ranges.map(r => [r.field, r.max])))

    const setMin = (field: string, value?: string) => {
        setMinValues((f) => {
            return {
                ...f,
                [field]: value
            }
        })
    }
    const setMax = (field: string, value?: string) => {
        setMaxValues((f) => {
            return {
                ...f,
                [field]: value
            }
        })
    }
    // const [query, setQuery] = useState<string>(filter?.query)
    // const [minMarketCap, setMinMarketCap] = useState<string>(filter?.minMarketCap)
    // const [maxMarketCap, setMaxMarketCap] = useState<string>(filter?.maxMarketCap)
    // const [minLiquidity, setMinLiquidity] = useState<string>(filter?.minLiquidity)
    // const [maxLiquidity, setMaxLiquidity] = useState<string>(filter?.maxLiquidity)
    // const [minVolume, setMinVolume] = useState<string>(filter?.minVolume)
    // const [maxVolume, setMaxVolume] = useState<string>(filter?.maxVolume)

    return <Modal title="Filters" onDismiss={onDismiss} minWidth={['100%', '100%', '400px']}>
        <Flex flexDirection="column">
            <SearchBox>
                <SearchIcon width={24} />
                <input
                    placeholder="Search by name, symbol or address"
                    value={query ?? ''}
                    onChange={(e) => setQuery(e.target.value)}
                />
                {
                    query?.length > 0 &&
                    <CloseIcon width={24} onClick={() => setQuery(undefined)} />
                }
            </SearchBox>

            <Flex marginTop="12px">
                <Divider />
                <FilterTitle style={{ whiteSpace: 'nowrap' }}>Filters (optional)</FilterTitle>
                <Divider />
            </Flex>

            {
                Object.entries(RANGES).map(([field, label]) =>
                    <InputRow key={field} flexDirection={['column', 'column', 'row']}>
                        <LabelContainer justifyContent={['center', 'center', 'flex-start']}>
                            <FilterLabel>{label}:</FilterLabel>
                        </LabelContainer>
                        <InputGroup flexDirection={['column', 'column', 'row']}>
                            <InputContainer>
                                <CurrencyBox/>
                                <StyledInput placeholder="Min" value={minValues[field] ?? ''} onChange={(e) => setNumber(e.target.value, (v) => setMin(field, v))} />
                            </InputContainer>
                            <InputContainer>
                                <CurrencyBox/>
                                <StyledInput placeholder="Max" value={maxValues[field] ?? ''} onChange={(e) => setNumber(e.target.value, (v) => setMax(field, v))} />
                            </InputContainer>
                        </InputGroup>
                    </InputRow>
                )
            }

            <Button minHeight="72px" onClick={() => {
                onDismiss?.()
                setFilter(() => {
                    const ranges = Object.keys(RANGES).map(field => {
                        const min = Number(minValues[field])
                        const max = Number(maxValues[field])
                        if (Number.isNaN(min) && Number.isNaN(max))
                            return undefined
                        return {
                            field, min: Number.isNaN(min) ? undefined : min, max: Number.isNaN(max) ? undefined : max
                        }
                    }).filter(Boolean)
                    return {
                        query, ranges
                    } as TokenFilter
                })
            }}>Apply</Button>
        </Flex>
    </Modal>
}